export type GetProjectRequest = {
  pjtId: string;
  dfnSetVerNum: string;
};
